<template>
  <v-layout row wrap>
    <el-upload class="upload-demo" 
    :action="source" 
    :on-success="onSuccess" 
    :file-list="fileList" 
    :on-remove="onRemove" 
    :list-type="listType" 
    :before-upload="onBeforeUpload"
    :limit="5" :show-file-list="isList"
    drag multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
      <slot :id="value">

      </slot>
      <!-- <v-btn flat>点击上传</v-btn> -->
    </el-upload>

  </v-layout>
</template>

<style scoped>

</style>

<script>
  import GhUpload from "./ghUpload.ts";
  export default GhUpload;
</script>